// extracted by mini-css-extract-plugin
export var infoRow = "_ue-2";
export var labelContainer = "_ue-0";
export var rightInfo = "_ue-1";